import app from '@devices/settings/device_settings/app.js';
import device_information from '@devices/settings/device_settings/device_information';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'ShellyWeatherStation',
	friendly_name: 'Weather Station',
	category: 'sensor',
	family: 'sensor',
	isPM: false,
	modes: {
		sensor: {
			availableViews: ['basic', 'advanced'],
			channels: 1,
			notifications: ['device_problem', 'lowBattery'],
			charts: false,
			bluetooth_settings: [],
			settings: [
				{
					title: 'sensor_settings',
					components: [
						{
							title: 'weather_station_ble_settings',
							component: 'weather_station_ble_settings',
						},
					],
				},
				{
					title: 'geo_location_and_elevation',
					components: [
						{
							title: 'geo_location_and_elevation',
							component: 'weather_station_device_location',
						},
					],
				},
				app,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'firmware_version', component: 'firmware_update_ble' },
						{ title: 'factory_reset', component: 'factory_reset_ble' },
					],
				},
				device_information,
			],
		},
	},
};
